import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { MaintenancePage } from '@adsk/bim360-matrix-react-components';
import T from 'i18n-react';
import lodashGet from 'lodash/get';
import { childrenType } from '../../constants/proptype-validation';
import featureFlags, { FEATURE_FLAGS } from '../../utils/featureFlags';
import { connect } from '../../redux/connect';
import { getCurrentUser } from '../../redux/selectors';

export const MaintenanceMessage = () => (
  <div className="maintenance-mode">
    <div className="maintenance-mode_title">{T.translate('maintenanceMode.title')}</div>
    <div className="maintenance-mode_description">{T.translate('maintenanceMode.description')}</div>
    <a href="https://health.autodesk.com/">{T.translate('maintenanceMode.toGoHealth')}</a>
  </div>
);

const MaintenanceMode = ({ children, currentUser }) => {
  const webFF = featureFlags.get(FEATURE_FLAGS.MAINTENANCE_MODE);
  const backendFF = !!lodashGet(currentUser, 'attributes.maintenanceEndDate');

  const isMaintenanceMode = (() => {
    switch (webFF) {
      case 'OFF':
        return false;
      case 'ON':
        return true;
      case 'Backend':
        return backendFF;
      default:
        return false;
    }
  })();

  if (isMaintenanceMode) {
    return <MaintenancePage message={<MaintenanceMessage />} />;
  }

  return <Fragment>{children}</Fragment>;
};

MaintenanceMode.propTypes = {
  children: childrenType.isRequired,
  currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps)(MaintenanceMode);
